module.exports = __webpack_public_path__ + "img/right_arrow_icon.1f777bec.svg";